export const OPERATIONS_MODULE_KEY = 100101;

export const STATIC_DASHBOARD_CARD_ICON = 'assets/svgIcons/patient_funnel.svg';

export interface StaticDashboardDef {
  id: string;
  title: string;
  assetPath: string;
  icon: string;
}

export const STATIC_DASHBOARDS_BY_MODULE: Record<number, StaticDashboardDef[]> = {
  [OPERATIONS_MODULE_KEY]: [
    {
      id: 'data-lineage',
      title: 'Data Lineage Report',
      assetPath: 'assets/static-dashboards/data-lineage.html',
      icon: STATIC_DASHBOARD_CARD_ICON,
    },
  ],
};

export function getStaticDashboardsForModule(
  moduleKey: number
): StaticDashboardDef[] {
  return STATIC_DASHBOARDS_BY_MODULE[Number(moduleKey)] ?? [];
}

export function getStaticDashboardById(
  dashboardId: string
): StaticDashboardDef | undefined {
  for (const dashboards of Object.values(STATIC_DASHBOARDS_BY_MODULE)) {
    const match = dashboards.find((item) => item.id === dashboardId);
    if (match) {
      return match;
    }
  }
  return undefined;
}

export function mapStaticDashboardToCard(
  def: StaticDashboardDef
): Record<string, unknown> {
  return {
    dashboard_nm: def.title,
    hide_flg: 'N',
    access_flg: 'Y',
    hist_access_flg: 'H',
    isStaticDashboard: true,
    staticDashboardId: def.id,
    active_image: def.icon,
  };
}
